"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
var colors_1 = require("@mui/material/colors");
// PURPLE
// main: '#3b0e3c',
// light: '#9C869D',
// dark: '#1E061F',
// contrastText: '#ffffff',
// RED
// main: "#E62D25",
// light: "#faabab",
// dark: "#930505",
// contrastText: "#ffffff",
// BLUE
// main: "#22a1ec",
// light: "#cbe4f3",
// dark: "#11618f",
// contrastText: "#ffffff",
exports.palette = {
    mode: "light",
    primary: {
        main: "#3B0E3C",
        light: "#FAF1FA",
        dark: "#1E061F",
        contrastText: "#ffffff",
    },
    secondary: {
        main: "#E62D25",
        light: "#faabab",
        dark: "#930505",
        contrastText: "#ffffff",
    },
    error: {
        main: "#E62D25",
        light: "#faabab",
        dark: "#930505",
        contrastText: "#ffffff",
    },
    warning: {
        main: "#e9c260",
        light: "#f3e0af",
        dark: "#aa7c06",
        contrastText: "#ffffff",
    },
    info: {
        main: "#b7b7b7",
        light: "#dddddd",
        dark: "#323232",
        contrastText: "#ffffff",
    },
    success: {
        main: "#30E36D",
        light: "#aff3c6",
        dark: "#2e864c",
        contrastText: "#ffffff",
    },
    divider: "#B7B7B7",
    background: {
        default: "#FFFFFF",
        paper: "#FFFFFF",
    },
    text: {
        primary: colors_1.grey[800],
        secondary: colors_1.grey[700],
        disabled: colors_1.grey[500],
    },
};
//# sourceMappingURL=palette.js.map